export function getTestimonialRange(total: number, columns: number, index: number) {
  const visible = Math.min(total, Math.max(1, columns));
  const maxStart = Math.max(0, total - visible);
  const start = Math.min(Math.max(0, index), maxStart);
  return { start, end: start + visible, maxStart };
}

export function nextTestimonialIndex(index: number, maxStart: number, direction: -1 | 1) {
  const positions = maxStart + 1;
  return (index + direction + positions) % positions;
}

export function splitTestimonialQuote(content: string, emphasis?: string) {
  const index = emphasis ? content.indexOf(emphasis) : -1;
  if (index === -1 || !emphasis) return { before: content, emphasis: "", after: "" };
  return { before: content.slice(0, index), emphasis, after: content.slice(index + emphasis.length) };
}
